import React, { useCallback } from 'react';
import { Box } from '@common-fe/common-fe';

import useFilesInDocumentStore from '@/components/controls/DropScan/useFilesInDocument.store';
import { LMN_UPLOAD_STORE_KEY } from '@/modules/MyDocuments/myDocuments.types';
import { useMyMoneyFormStore } from '@/modules/UseMyMoney/stores';

import AddProofOfNecessityButton from './AddProofOfNecessityButton';
import PreviewProofOfNecessity from './PreviewProofOfNecessity';

interface Props {
  setIsSelectLmnPopupVisible?: (value: boolean) => void;
  onDeleteLmn: (lmnId?: string) => Promise<unknown>;
}

const ClaimSummaryProofOfNecessity: React.FC<Props> = ({ setIsSelectLmnPopupVisible, onDeleteLmn }) => {
  const { values: formValues, handleSetFormValues } = useMyMoneyFormStore();
  const { values: { files }, handleReset } = useFilesInDocumentStore(LMN_UPLOAD_STORE_KEY);

  const handleDeleteLmn = useCallback(async () => {
    if (formValues?.lmnId) {
      await onDeleteLmn(formValues?.lmnId);
      handleSetFormValues({ lmnId: undefined });
      handleReset();
    }
  }, [formValues?.lmnId, onDeleteLmn, handleSetFormValues, handleReset]);

  const handleOpenAddLmnPopup = useCallback(() => {
    setIsSelectLmnPopupVisible?.(true);
  }, [setIsSelectLmnPopupVisible]);

  if ((formValues?.lmnId && files?.length) || formValues?.isLmnWasUploaded) {
    return (
      <Box
        data-testId="claim-summary-proof-of-necessity"
        margin={{ top: 'spacing24' }}
      >
        <PreviewProofOfNecessity
          lmnId={formValues?.lmnId}
          lmnFile={files?.[0]}
          handleDeleteLmn={handleDeleteLmn}
          handleOpenAddLmnPopup={handleOpenAddLmnPopup}
        />
      </Box>
    );
  }

  return (
    <Box
      data-testId="claim-summary-proof-of-necessity"
      margin={{ top: 'spacing8' }}
    >
      <AddProofOfNecessityButton handleOpenAddLmnPopup={handleOpenAddLmnPopup} />
    </Box>
  );
};

export default ClaimSummaryProofOfNecessity;
